import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { handleAxiosError } from "../config/action-config";
import { useSelector } from "react-redux";
import { getTeamWorkload } from "../api/chart";
import { CircularProgress } from "@mui/material";
import { ChartTable } from "../config/grid-columns-defs";
const CustomizedBarChartTable = ({ id, refresh }) => {
  const user = useSelector((state) => state.user);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (user.token) {
      getChart();
    }
    return;
  }, [refresh]);
  useEffect(() => {
    if (user.token) {
      getChart();
    }
    return;
  }, []);
  const PercentCellRenderer = ({ value }) => {
    const percentValue = parseFloat(value);

    const containerStyle = {
      display: "flex",
      alignItems: "center",
    };

    const percentStyle = {
      height: "30px",
      width: "250px",
      backgroundColor: "lightgray",
      borderRadius: "25px",
      overflow: "hidden",
    };

    const progressBarStyle = {
      height: "100%",
      width: `${percentValue}%`,
      backgroundColor: `hsl(${percentValue * 1.2}, 70%, 50%)`,
      color: "white",
      fontWeight: "bold",
      textAlign: "center",
      borderRadius: "25px",
      overflow: "hidden",
      transition: "width 0.5s ease-in-out",
    };

    const percentValueStyle = {
      marginLeft: "10px",
    };

    return (
      <div style={containerStyle}>
        <div style={percentStyle}>
          <div style={progressBarStyle}></div>
        </div>
        <div style={percentValueStyle}>{percentValue.toFixed(1)}%</div>
      </div>
    );
  };

  async function getChart() {
    setLoading(true);
    try {
      const { data } = await getTeamWorkload(id, user.token);
      setChartData(data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleAxiosError(error);
    }
  }

  const gridOptions = {
    columnDefs: ChartTable,
    defaultColDef: {
      sortable: true,
      resizable: true,
    },
    rowData: chartData,
    frameworkComponents: {
      percentCellRenderer: PercentCellRenderer,
    },
  };
  const rowHeight = 38;
  return (
    <div
      className="ag-theme-alpine"
      //style={{ height: "500px", width: "100%" }}
    >
      {loading === true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <AgGridReact
          gridOptions={gridOptions}
          rowClass="ag-row ag-custom-table"
          headerClass="ag-header-cell ag-custom-table"
          cellClass="ag-cell ag-custom-table"
          domLayout="autoHeight"
          headerHeight="38"
          rowHeight={rowHeight}
          defaultColDef={{
            resizable: true,
            flex: 1,
          }}
        />
      )}
    </div>
  );
};

export default CustomizedBarChartTable;
